var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 36.3592H15C7.5 36.3592 3.75 34.4425 3.75 24.8592V15.2759C3.75 7.60921 7.5 3.77588 15 3.77588H30C37.5 3.77588 41.25 7.60921 41.25 15.2759V24.8592C41.25 32.5259 37.5 36.3592 30 36.3592H29.0625C28.4812 36.3592 27.9188 36.6468 27.5625 37.1259L24.75 40.9593C23.5125 42.6459 21.4875 42.6459 20.25 40.9593L17.4375 37.1259C17.1375 36.7043 16.4625 36.3592 15.9375 36.3592Z",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.6748L11.25 20.5081L15 24.3415",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.6748L33.75 20.5081L30 24.3415",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 16.0425L20.625 24.9742",
    stroke: "#5E00D8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9ee4dc804adc78e0ff9d0848afa0e3cc.svg";
export { ForwardRef as ReactComponent };